<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Transporter" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New Transporter</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input disabled class="w-full" label="ID *" v-model="data.id" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Transporter Code *" v-model="data.transporter_code" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Name" v-model="data.name" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="address_1 " v-model="data.address_1" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="address_2 " v-model="data.address_2" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="PIC" v-model="data.pic" />
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Email" v-model="data.email" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Phone" v-model="data.phone" />
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Area ID *</label>
                                <v-select :options="areaOptions" v-model="data.area_id" label="name" :reduce="area_id => area_id.id" @search="searchArea"></v-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="City" v-model="data.city" />
                            </div>
                        </div>
                        <div class="vx-row mb-4">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Post Code *" v-model="data.post_code" />
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import InboundItem from '@/components/InboundItem.vue'
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
			InboundItem
		},
		data(){
			return {
                isLoading: false,
                data: {
                    id: '',
                    transporter_code: '',
                    name: '',
                    address_1: '',
                    address_2: '',   
                    pic: '',   
                    email: '',   
                    phone: '',   
                    area_id: null,   
                    city: '',   
                    post_code: '',  
                },
                areaOptions: [],
                maxRetry: 10,
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData(api) {
                return this.$http.get(api)
            },
            searchArea(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/areas/filter/search', data)
                    .then(res => {
                        this.areaOptions = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchArea(search, loading)
                    })
                }
            },
            submitForm() {
                this.isLoading = true
                this.$http.post('master/transporters', this.data)
                .then(res => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Saved Successfully',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Transporter added'
                    })
                    this.$router.push({ path: '/master/transporter' })
                })
                .catch(error => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Error saving'
                    })
                })
                .then(() => {
                    this.isLoading = false
                })
            },
            back() {
                if(this.data.name != '' || this.data.client_code != '' || this.data.address_1 != '' ||  this.data.address_2 != '' || this.data.area_id != '' || this.data.city != '' || this.data.post_code != '' || this.data.clienttype_id != '') {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.go(-1),
                    })
                }
                else{
                    this.$router.go(-1)
                }
            },
            fetchAllData() {
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                Promise.all([this.fetchData('master/areas/filter/getlist'), this.fetchData('master/clienttypes')])
                .then(this.$http.spread((areas, clienttypes) => {
                    this.areaOptions = areas.data
                    this.clientTypeOptions = clienttypes.data
                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)
                }))
                .catch(() => {
                    if(this.maxRetry == 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.fetchAllData()
                                this.maxRetry = 10
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: 'Yes',
                            cancelText: 'No'
                        });
                        return;
                    }
                    this.fetchAllData()
                })
            }
        },
        mounted(){
            this.fetchAllData()
        },
	}
</script>